import * as Html from "../util/Html.ts";
export {SearchController,easyScorer,applyScorer}

class SearchController{
  constructor(nodeResult,searchInput,TPL_result,TPL_noresult,datasCache,scoreSearch){
    this.nodeResult = nodeResult;
    this.searchInput = searchInput;
    this.TPL_result = TPL_result;
    this.TPL_noresult = TPL_noresult;
    this.datasCache = datasCache;
    this.scoreSearch = scoreSearch;
    
    this.wrapOnInput = ()=>this.update();
    
    this.searchInput.on('input',this.wrapOnInput);
  }
  async update(){
    var 
      searchText = this.searchInput.val(),
      searchResult = applyScorer(await this.datasCache.need(),this.scoreSearch,searchText);
    
    if(searchResult.length>0){
      Html.setHtmlArray(this.nodeResult,this.TPL_result,searchResult);
    }else{
      Html.setHtml(this.nodeResult,this.TPL_noresult,{searchText});
    }
    
  }
  destroy(){
    this.searchInput.off('input',this.wrapOnInput);
  }
}
function normalize(str){
  return str.trim().toLowerCase().normalize("NFD") .replace(/[\u0300-\u036f]/g, "")
}

function max(prev,next){
  return next>prev?next:prev; 
}
function easyScorer(data){
  return function(object,searchtext){
    if(!searchtext) return 1;
    return scoreObject(object,data,searchtext);
  }
}
function applyScorer(array,scorer,searchtext){
  var normalizedSearchText = normalize(searchtext)
  //map to scored object, and remove score <=0
  var searchResultScored = array.map(data=>{
    return {data,score:scorer(data,normalizedSearchText)}
  }).filter(scoredData=>scoredData.score>0);
  //sort by score
  searchResultScored.sort((a,b)=>b.score-a.score)
  //return result;
  return searchResultScored.map(scored=>scored.data);
}

function scoreString(property,scoreBase,normalizedSearchText){
  var idx =  property?normalize(property).indexOf(normalizedSearchText):-1;
  if(idx===0){
    return scoreBase+5;
  }else if(idx>0){
    return scoreBase+4;
  }else{
    return  0;
  }
}
function scoreArray(array,scoreBaseRoot,normalizedSearchText){
  return array.map(arrayItem=>{
    if(typeof arrayItem === 'string'){
      return scoreString(arrayItem,scoreBaseRoot,normalizedSearchText)  
    }else if(Array.isArray(arrayItem)){
      return scoreArray(arrayItem,scoreBaseRoot,normalizedSearchText)  
    }else{
      return scoreObject(arrayItem,scoreBaseRoot,normalizedSearchText)  
    }
  }).reduce(max,0)
}

function scoreObject(object,scoreBaseRoot,normalizedSearchText){
  return Object.entries(scoreBaseRoot).map(en=>{
    var 
      property = object[en[0]],
      scoreBase = en[1];
    if(typeof property === 'string'){
      return scoreString(property,scoreBase,normalizedSearchText)  
    }else if(Array.isArray(property)){
      if(property.length===0) return 0;
      return scoreArray(property,scoreBase,normalizedSearchText)  
    }else{
      return scoreObject(property,scoreBase,normalizedSearchText)  
    }
  }).reduce(max,0)
}
